import LoadingDots from 'components/shared/LoadingDots'

import { Icon } from '@driftt/tide-core-legacy'

import './style.styl'


const MultiSignatureTemplate = ({
  multiSignaturePreviewFetchPending,
  multiSignaturePreviewFetchFailed,
  onRefetchClick,
  viewingSignatureNumber,
  onNextSignatureClick,
  onPreviousSignatureClick,
  currentlyViewingSignature,
  doCycle,
}) => (
  multiSignaturePreviewFetchPending ?
    <div className="multiple-signature-loading"><p>Fetching your signature</p><LoadingDots /></div>
    :
    multiSignaturePreviewFetchFailed ?
      <div className="multiple-signature-failed"><Icon className="fetch-failed-warning" name="warning-circle" /><div>We could not get your signature. <a onClick={onRefetchClick}>Try again</a>?</div></div>
      :
      <div className="multiple-signature-container">
        {doCycle &&
          <div className="multiple-signature-cycle-container">
            <div className="multiple-signature-cycle-dir" onClick={onPreviousSignatureClick}><Icon className="multiple-signature-cycle-dir-icon" name="arrow-1-left" width={12} height={12} /></div>
            <div className="multiple-signature-cycle-num">{viewingSignatureNumber}</div>
            <div className="multiple-signature-cycle-dir" onClick={onNextSignatureClick}><Icon className="multiple-signature-cycle-dir-icon" name="arrow-1-right" width={12} height={12} /></div>
          </div>
        }
        <div dangerouslySetInnerHTML={{ __html: currentlyViewingSignature }} />
      </div>
)


export default MultiSignatureTemplate



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/MultiSignaturePreview/component.js